import React from "react";
import { Button, ButtonGroup } from "aible";

import HexGridContainer from "containers/Next/HexGrid";

import scales from "images/scales.svg";
import pfp from "images/profilePhoto.png";

import styles from "./style.module.css";

const fDatasetId = 6;
const fReportId = 17;

const MarketTile = (props) => {
  const { data, type, deleteConsultant, updateHireConsultant, updateIsCreateConsultant } = props;

  const renderStars = (numStars) => {
    return numStars === 5 ? (
      <div className={styles.ratingSection}>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
      </div>
    ) : numStars === 3 ? (
      <div className={styles.ratingSection}>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>☆</span>
        <span className={styles.starColor}>☆</span>
      </div>
    ) : numStars === 0 ? (
      <div className={styles.ratingSection}>
        <span className={styles.starColor}>☆</span>
        <span className={styles.starColor}>☆</span>
        <span className={styles.starColor}>☆</span>
        <span className={styles.starColor}>☆</span>
        <span className={styles.starColor}>☆</span>
      </div>
    ) : (
      <div className={styles.ratingSection}>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>★</span>
        <span className={styles.starColor}>☆</span>
      </div>
    );
  };

  const consultantType = () => {
    return (
      <div className={styles.marketTileContainer}>
        <div className={styles.marketTileHeader}>
          <div>
            <div className={styles.marketHeaderTitle}>{data.title}</div>
            <div>{data.subtitle}</div>
          </div>
          <div className={styles.marketHeaderButtons}>
            <a className={styles.marketLinkText}>View More</a>
            {data.isOwner ? (
              <ButtonGroup>
                <Button onClick={() => updateIsCreateConsultant(data)}>{"Edit"}</Button>
                <Button onClick={() => deleteConsultant(data.id)}>{"Delete"}</Button>
              </ButtonGroup>
            ) : (
              <Button
                type={data.isHire === true ? "primary" : "secondary"}
                onClick={() => updateHireConsultant(data.id, data.isHire === true ? false : true)}
              >
                {data.isHire === true ? "Hired" : "Ask for Help"}
              </Button>
            )}
          </div>
        </div>
        <div className={styles.marketTileBody}>
          <div className={styles.dataProjectHex}>{data.nDataProjects + " Data Projects"}</div>
          <div className={styles.aiProjectHex}>{data.nProjects + " AI Projects"}</div>
          <div className={styles.explorationsProjectHex}>{data.nExplorations + " Explorations"}</div>
          <div className={styles.deploymentsProjectHex}>{data.nDeployments + " Deployments"}</div>
        </div>
        <div className={styles.marketTileFooter}>
          <div className={styles.footerPrice}>$150/hr</div>
          {renderStars(data.stars)}
          <div className={styles.ratingText}>{data.nRatings + " Ratings"}</div>
        </div>
      </div>
    );
  };

  const jobType = () => {
    const { updateHireJob, deleteJob, updateIsCreateJob, isPreview, nextId } = props;

    return (
      <div className={styles.marketTileContainer}>
        <div className={styles.minimap}>
          <HexGridContainer
            id={nextId ? nextId : data?.nextId !== undefined ? data?.nextId : fReportId}
            isMini
            mType={"MODELS"}
            isPreview
          />
        </div>
        <div className={styles.marketTileHeader}>
          <div>
            <div className={styles.marketHeaderTitle}>{data.title}</div>
            <div>{data.subtitle}</div>
          </div>
          <div className={styles.marketHeaderButtons}>
            {isPreview !== true && <a className={styles.marketLinkText}>View More</a>}
            {isPreview === true ? (
              <div />
            ) : data.isOwner ? (
              <ButtonGroup>
                <Button onClick={() => updateIsCreateJob(data)}>{"Edit"}</Button>
                <Button onClick={() => deleteJob(data.id)}>{"Delete"}</Button>
              </ButtonGroup>
            ) : (
              <Button
                type={data.isHire === true ? "primary" : "secondary"}
                onClick={() => updateHireJob(data.id, data.isHire === true ? false : true)}
              >
                {data.isHire === true ? "Hired" : "Hire Me"}
              </Button>
            )}
          </div>
        </div>
        <div className={styles.marketTileBody}>
          <div>{data.textBody}</div>
        </div>
        <div className={styles.marketItem}>
          <div>{data.contractLength}</div>
        </div>
        <div className={styles.marketItem}>
          <div>{data.contractType}</div>
        </div>
        <div className={styles.marketItem}>
          <div>{"$ " + data.budget + " " + (data.rateType ? data.rateType : "Per Hour")}</div>
        </div>
        <div className={styles.marketTileFooter}>
          <div>{data.cHoursAgo === undefined ? "New" : "Posted " + data.cHoursAgo + " hours ago"}</div>
        </div>
      </div>
    );
  };

  const managementType = () => {
    const { stage, updateIsReviewingJob, viewAndStartReplay, history } = props;

    const reviewPayment = () => {
      updateIsReviewingJob(true);
      history.push("/next/" + fDatasetId + "/" + fReportId);
    };

    return (
      <div className={styles.marketTileContainer}>
        <div className={styles.marketTileBody} style={{ justifyContent: "flex-start", flexFlow: "column" }}>
          {stage && stage === "completed" && <div className={styles.managementReadyBanner}>Ready For Review</div>}
          <div className={styles.managementTopContent}>
            <div className={styles.managementLeftColumn} style={{ paddingBottom: "0px" }}>
              <div className={styles.minimap}>
                <HexGridContainer
                  id={data?.nextId !== undefined ? data?.nextId : fReportId}
                  isMini
                  mType={data?.contractType === "Data Exploration" ? "EXPLORE" : "MODELS"}
                  isPreview
                />
              </div>
              {stage && stage !== "open" && (
                <div className={styles.managementNamePlate}>
                  <img className={styles.hexagon} src={pfp} alt="profile photo" />
                  <div className={styles.managementNamePlateText}>
                    <div style={{ fontWeight: "bold" }}>{"Jane C."}</div>
                    <div>Data Scientist</div>
                  </div>
                </div>
              )}
            </div>
            <div className={styles.blueprintText}>
              <div className={styles.blueprintTextTitle}>{data?.contractType}</div>
              <div style={{ marginBottom: "10px" }}>
                {data.cHoursAgo === undefined ? "New" : "Posted " + data.cHoursAgo + " hours ago"}
              </div>
              <div className={styles.blueprintTextLine}>{data.textBody}</div>
              <div className={styles.managementBubble}>{`Estimated Hours: ${data.contractLength}`}</div>
              {stage && stage !== "open" && (
                <div
                  className={styles.managementBubble}
                  style={{
                    backgroundColor: stage === "completed" ? "#F8CD7E" : "#FFF"
                  }}
                >
                  {stage === "worked" ? `Hours Tracked: 8` : `Hours Tracked: 19`}
                </div>
              )}
              <div className={styles.managementBubble}>{`Due Date: July 27`}</div>
              <div className={styles.managementPriceBubble}>
                {"Rate: $ " + data.budget + " " + (data.rateType ? data.rateType : "Per Hour")}
              </div>
            </div>
          </div>
          {stage && stage === "open" && (
            <div className={styles.managementFooterRow} style={{ borderTop: "1px #C8CAD4 solid", marginTop: "10px" }}>
              <Button
                type="secondary"
                style={{ marginRight: "10px", marginTop: "10px" }}
                onClick={() => viewAndStartReplay(data?.nextId === undefined ? fReportId : data?.nextId, "Aible User")}
              >
                Watch Video Summary
              </Button>
              <Button type="secondary" style={{ marginTop: "10px" }}>
                Apply for Job
              </Button>
            </div>
          )}
          {stage && stage === "completed" && (
            <React.Fragment>
              <div className={styles.managementWarning}>
                <div className={styles.managementWarningBoldText}>
                  <img src={scales} alt="scales of judgment" style={{ marginRight: "10px" }} />
                  Aible's Verdict: Claim is Inaccurate
                </div>
                <div className={styles.managementWarningBoldText}>Why Aible Gace this Verdict</div>
                <div>• This job usually takes 6 fewer hours than submitted</div>
                <div>• 3 hours were not tracked within the Aible platform</div>
              </div>
              <div className={styles.managementFooterRow}>
                <Button
                  type="secondary"
                  style={{ marginRight: "10px" }}
                  onClick={() => viewAndStartReplay(data?.nextId === undefined ? fReportId : data?.nextId, "Jane C.")}
                >
                  Watch Video Replay
                </Button>
                <Button type="secondary" onClick={() => reviewPayment()}>
                  Review Payment
                </Button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  };

  const blueprintType = () => {
    return (
      <div className={styles.marketTileContainer}>
        <div className={styles.marketTileBody} style={{ justifyContent: "flex-start" }}>
          <div className={styles.blueprintContainer}>
            <div className={styles.blueprintContainerHeader}>{data.title}</div>
            <div className={styles.blueprintContainerTextLine}>{data.outcome}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.columns} Columns`}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.datasets} Datasets`}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.cHoursAgo} hours ago`}</div>
          </div>
          <div className={styles.blueprintText}>
            <div className={styles.blueprintTextTitle}>Blueprint Outline</div>
            <div className={styles.blueprintTextLine}>
              1. Aible will optimize your Win % by recommending which Opportunities to Pursue from the list of all
              available Leads
            </div>
            <div className={styles.blueprintTextLine}>
              2. Aible will also show how to allocate your Resourcing in a way that optimizes Revenue and Profit
            </div>
            <div className={styles.blueprintTextLine}>
              3. Aible will conserve Resourcing by recommending Nurture for Leads where Pursue is less valuable
            </div>
            <div className={styles.blueprintTextLine}>4. Aible will measure expected optimization using units of $</div>
          </div>
        </div>
        <div className={styles.marketTileFooter}>
          <div className={styles.footerPrice}>{`$${data.price}`}</div>
          {renderStars(data.stars)}
          <div className={styles.ratingText}>{data.nRatings + " Ratings"}</div>
          <div className={styles.footerCreatedByText}>
            {`Created By: `}
            <div style={{ color: "#7e69d7", marginLeft: "5px" }}>{`${data.createdBy}`}</div>
          </div>
        </div>
      </div>
    );
  };

  const datasetType = () => {
    const { data } = props;
    return (
      <div className={styles.marketTileContainer}>
        <div className={styles.marketTileBody} style={{ justifyContent: "flex-start" }}>
          <div className={styles.blueprintContainer}>
            <div className={styles.blueprintContainerHeader} style={{ backgroundColor: "#34D399" }}>
              {data.title}
            </div>
            <div className={styles.blueprintContainerTextLine}>{data.outcome}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.columns} Columns`}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.rows} rows`}</div>
            <div className={styles.blueprintContainerTextLine}>{`${data.cHoursAgo} hours ago`}</div>
          </div>
          <div className={styles.blueprintText}>
            <div className={styles.blueprintTextTitle}>Data Description</div>
            <div className={styles.blueprintTextLine}>{data.description}</div>
          </div>
        </div>
        <div className={styles.marketTileFooter}>
          <div className={styles.footerPrice}>{`$${data.price}`}</div>
          {renderStars(data.stars)}
          <div className={styles.ratingText}>{data.nRatings + " Ratings"}</div>
          <div className={styles.footerCreatedByText}>
            {`Created By: `}
            <div style={{ color: "#7e69d7", marginLeft: "5px" }}>{`${data.createdBy}`}</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <React.Fragment>
      {type === "hire consultants" ? (
        consultantType()
      ) : type === "job postings" ? (
        jobType()
      ) : type === "find blueprints" ? (
        blueprintType()
      ) : type === "find data" ? (
        datasetType()
      ) : type === "manage jobs" ? (
        managementType()
      ) : (
        <div>Coming soon</div>
      )}
    </React.Fragment>
  );
};

export default MarketTile;
